// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root:has(.lsn-page-dashboard) {
  display: flex !important;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
}
#root:has(.lsn-page-dashboard) .lsn-page {
  min-height: unset;
  flex: 1 1 0px;
}
.lsn-page-dashboard {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  flex: 1 1 0px;
}
.lsn-page-dashboard .link-jump-to-content {
  position: absolute;
  min-width: 200px;
  background-color: var(--main-white);
  box-shadow: 0px 0px 0px 1px var(--main-primary-color) inset;
  cursor: pointer;
  top: inherit;
  margin-top: -1rem;
  margin-left: -1rem;
  transition: height 0.5s;
  height: 0;
}
.lsn-page-dashboard .link-jump-to-content a {
  width: 100%;
  height: 100%;
  display: block;
  padding: 4px 10px 3px 20px;
  outline: none;
  color: var(--main-primary-color);
  opacity: 0;
}
.lsn-page-dashboard .link-jump-to-content:active,
.lsn-page-dashboard .link-jump-to-content:visited,
.lsn-page-dashboard .link-jump-to-content:focus,
.lsn-page-dashboard .link-jump-to-content:focus-within {
  height: 1.5rem;
}
.lsn-page-dashboard .link-jump-to-content:active a,
.lsn-page-dashboard .link-jump-to-content:visited a,
.lsn-page-dashboard .link-jump-to-content:focus a,
.lsn-page-dashboard .link-jump-to-content:focus-within a {
  opacity: 1;
  transition: opacity 0.5s 0.5s;
}
.lsn-page-dashboard h1 {
  margin-top: 0;
  margin-bottom: 0;
}
.lsn-page-dashboard .lsn-no-dashboard-requests {
  color: var(--main-dark-red);
  text-align: center;
}
.lsn-page-dashboard .lsn-container {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
  margin: 0 auto 0;
  flex: 1 1 0px;
}
.lsn-page-dashboard .evaluations-wrapper {
  padding: 0.45rem 0;
  background-color: var(--main-bg-color-darker);
  border-radius: var(--main-border-radius);
  border: var(--main-border-width) solid var(--main-border-color);
  row-gap: 1rem;
  display: flex;
  flex-direction: row;
  height: 100%;
  max-height: 100%;
  flex: 1 1 0px;
}
.lsn-page-dashboard #recommendations {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.lsn-page-dashboard .evaluations-header-wrapper {
  align-items: center;
  margin-bottom: 20px;
  row-gap: 10px;
}
.lsn-page-dashboard .scroll-container {
  height: 100vh;
  max-height: 100%;
  padding: 0 1.5rem 0 0;
  margin-right: -1.5rem;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1 1 0px;
}
@media (max-width: 840px) {
  .lsn-page-dashboard .evaluations-wrapper {
    display: grid;
    grid-template-rows: auto 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AACF;AALA;EAOI,iBAAA;EACA,aAAA;AACJ;AAGA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AADF;AALA;EASI,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,2DAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;AADJ;AAjBA;EAqBM,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,aAAA;EACA,gCAAA;EACA,UAAA;AADN;AAII;;;;EAIE,cAAA;AAFN;AAFI;;;;EAOI,UAAA;EACA,6BAAA;AACR;AAvCA;EA4CI,aAAA;EACA,gBAAA;AAFJ;AA3CA;EAiDI,2BAAA;EACA,kBAAA;AAHJ;AA/CA;EAsDI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAJJ;AAvDA;EA+DI,kBAAA;EACA,6CAAA;EACA,wCAAA;EACA,+DAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AALJ;AAnEA;EA4EI,aAAA;EACA,sBAAA;EACA,gBAAA;AANJ;AAxEA;EAkFI,mBAAA;EACA,mBAAA;EACA,aAAA;AAPJ;AA7EA;EAwFI,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AARJ;AAYA;EACE;IACE,aAAA;IACA,4BAAA;EAVF;AACF","sourcesContent":["#root:has(.lsn-page-dashboard) {\n  display: flex !important;\n  flex-direction: column;\n  max-height: 100%;\n  height: 100%;\n\n  .lsn-page {\n    min-height: unset;\n    flex: 1 1 0px;\n  }\n}\n\n.lsn-page-dashboard {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 100%;\n  flex: 1 1 0px;\n\n  .link-jump-to-content {\n    position: absolute;\n    min-width: 200px;\n    background-color: var(--main-white);\n    box-shadow: 0px 0px 0px 1px var(--main-primary-color) inset;\n    cursor: pointer;\n    top: inherit;\n    margin-top: -1rem;\n    margin-left: -1rem;\n    transition: height .5s;\n    height: 0;\n\n    a {\n      width: 100%;\n      height: 100%;\n      display: block;\n      padding: 4px 10px 3px 20px;\n      outline: none;\n      color: var(--main-primary-color);\n      opacity: 0;\n    }\n\n    &:active,\n    &:visited,\n    &:focus,\n    &:focus-within {\n      height: 1.5rem;\n\n      a {\n        opacity: 1;\n        transition: opacity .5s .5s;\n      }\n    }\n  }\n\n  h1 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .lsn-no-dashboard-requests {\n    color: var(--main-dark-red);\n    text-align: center;\n  }\n\n  .lsn-container {\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;\n    height: 100%;\n    margin: 0 auto 0;\n    flex: 1 1 0px;\n  }\n\n  .evaluations-wrapper {\n    padding: .45rem 0;\n    background-color: var(--main-bg-color-darker);\n    border-radius: var(--main-border-radius);\n    border: var(--main-border-width) solid var(--main-border-color);\n    row-gap: 1rem;\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    max-height: 100%;\n    flex: 1 1 0px;\n  }\n\n  #recommendations {\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;\n  }\n\n  .evaluations-header-wrapper {\n    align-items: center;\n    margin-bottom: 20px;\n    row-gap: 10px;\n  }\n\n  .scroll-container {\n    height: 100vh;\n    max-height: 100%;\n    padding: 0 1.5rem 0 0;\n    margin-right: -1.5rem;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    overflow-y: auto;\n    flex: 1 1 0px;\n  }\n}\n\n@media (max-width: 840px) {\n  .lsn-page-dashboard .evaluations-wrapper {\n    display: grid;\n    grid-template-rows: auto 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
